import React from 'react';  // eslint-disable-line

const Exclamation = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <g fill="none" fillRule="evenodd">
                { /* eslint-disable-next-line */}
                <circle cx="7.5" cy="7.5" r="7.5" fill={props.color ? props.color : '#979797'} />
                <path fill="#FFF" fillRule="nonzero" d="M6.792 3.6h1.776l-.3 5.616H7.08L6.792 3.6zm.888 8.484a.955.955 0 0 1-.696-.27.895.895 0 0 1-.276-.666c0-.264.092-.484.276-.66a.967.967 0 0 1 .696-.264.93.93 0 0 1 .678.264c.18.176.27.396.27.66s-.09.486-.27.666a.92.92 0 0 1-.678.27z" />
            </g>
        </svg>
    );
};

export default Exclamation;
